import $axios from "../api/accessor";
import { $api } from "../api/api";

export const BalanceServices = {
  async getBalance() {
    let response = await $axios
      .get($api("balance"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getBalanceHistory() {
    let response = await $axios
      .get($api("get_balanceHistory"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async getMyBalance() {
    let response = await $axios
      .get($api("get_balance"), {
        headers: {
          "Accept-Language": "az",
        },
      })
      .catch((err) => {
        return err.response;
      });
    return {
      data: response?.data ? response?.data : [],
      status: response?.status,
    };
  },
  async PostBalance(payload: { amount: string; card_id?: number; payment_provider?: string }) {
    try {
      const response = await $axios.post($api("post_balance"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async PostBalanceDirectPay(payload: { amount: string }) {
    try {
      const response = await $axios.post($api("balance_direct_pay"), payload);
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },

  async checkCallback(trans_id: string) {
    try {
      const response = await $axios.get($api("check_callback", { trans_id }));
      return response;
    } catch (error: any) {
      throw error.response ? error.response.data : error.message;
    }
  },
};
